export default "__VITE_ASSET__BN$8zP0O__"